export default __webpack_public_path__ + "static/media/coral-delete.d33fdcd1.svg";